<template>
  <div class="survey-question-select">
    <select
      :value="modelValue"
      class="survey-question-select__control"
      @change="onChange($event.target.value)"
    >
      <option value="" disabled>選択してください</option>
      <option v-for="option in question.options" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
    <img
      src="@/assets/img/arrow/svg/arrow-bottom-gray-12px.svg"
      width="12"
      height="12"
      class="survey-question-select__arrow"
    />
  </div>
</template>

<script>
export default {
  name: "SurveyQuestionSelect",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    question: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_survey.scss";

.survey-question-select {
  position: relative;

  &__arrow {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &__control {
    @extend %survey-question-control;
    padding: 12px 36px 12px 10px;
    cursor: pointer;
  }
}
</style>
